import type { EnvironmentConfig } from './types';

/**
 * Share of API calls sampled for timing telemetry when nothing overrides it.
 *
 * Ten percent is enough for stable percentiles at our call volume without the
 * telemetry itself becoming meaningful traffic on a poor connection. Raise it
 * per-environment with VITE_TELEMETRY_SAMPLE_PERCENT.
 */
export const DEFAULT_TELEMETRY_SAMPLE_PERCENT = 10;

/**
 * Environment configurations matched by hostname pattern.
 * Order matters - first match wins.
 */
export const ENVIRONMENT_CONFIGS: EnvironmentConfig[] = [
  // Localhost development
  {
    pattern: /^(localhost|127\.0\.0\.1)$/,
    legacyApiBaseUrl: 'http://localhost:8080',
    apiBaseUrl: 'http://localhost:5050',
    branding: 'praxes',
    environment: 'development',
    callerRatingMandatory: true,
    useCookieAuth: true,
    connectUseCookieAuth: true,
    telemetrySamplePercent: DEFAULT_TELEMETRY_SAMPLE_PERCENT,
  },
  // Beta environment (staging)
  {
    pattern: /beta\.praxesteam\.ca/,
    legacyApiBaseUrl: 'https://beta.praxesteam.ca',
    apiBaseUrl: 'https://api.beta.praxesteam.ca',
    branding: 'praxes',
    environment: 'beta',
    callerRatingMandatory: true,
    useCookieAuth: true,
    connectUseCookieAuth: true,
    telemetrySamplePercent: DEFAULT_TELEMETRY_SAMPLE_PERCENT,
  },
  // Praxes production
  {
    pattern: /praxes\.ca/,
    legacyApiBaseUrl: 'https://secure.praxes.ca',
    apiBaseUrl: 'https://api.secure.praxes.ca',
    branding: 'praxes',
    environment: 'praxes',
    callerRatingMandatory: true,
    useCookieAuth: true,
    connectUseCookieAuth: true,
    telemetrySamplePercent: DEFAULT_TELEMETRY_SAMPLE_PERCENT,
  },
  // RMI production
  {
    pattern: /rmi\.emwerx\.com/,
    legacyApiBaseUrl: 'https://rmi.emwerx.com',
    apiBaseUrl: 'https://api.rmi.emwerx.com',
    branding: 'rmi',
    environment: 'rmi',
    callerRatingMandatory: false,
    useCookieAuth: false,
    connectUseCookieAuth: false,
    telemetrySamplePercent: DEFAULT_TELEMETRY_SAMPLE_PERCENT,
  },
];
